module.exports = __webpack_public_path__ + "static/media/Email-Sent@2x.fec51b22.png";